module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9432084226baf93e8b19ba4663dd1d98.gif";